import { authAxios } from "services";

export const overallPerformance = (vehicleTypeId = null) =>
  authAxios().get(
    `/insights/overall-performance${vehicleTypeId ? `?vehicle_type_id=${vehicleTypeId}` : ""}`
  );

export const getDashboardStats = () => authAxios().get("/insights/dashboard-stats");
